module.exports = __webpack_public_path__ + "media/images/lb/756-c1db9477f07e54839819274b30311f4b.svg";